import React from 'react'
import Upload from '../utils/Upload'

function htrDemo() {
    return (
      <div >
        <h1>HTR DEMO!!</h1>
        <div>
            <Upload />
        </div>
      </div>
    );
  }
  
  export default htrDemo;